import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { PreviewProvider } from './PreviewProvider';
import { WixFlowProvider } from './WixFlowProvider';
export const WixFlow = props => props.flowContext ? /*#__PURE__*/React.createElement(WixFlowProvider, _extends({
  flowContext: props.flowContext
}, props)) : /*#__PURE__*/React.createElement(PreviewProvider, props);
//# sourceMappingURL=WixFlow.js.map